import config from '../config';
import aaveSwapABI from './json/aave/swap';
import paaveRewardsabi from './json/paave/rewards';
import atriCryptoSwap from './json/atricrypto/swap';
import atriCryptoZap from './json/atricrypto/zap';
import renSwapABI from './json/ren-polygon/swap';


const infura_url = config.rpcUrl;

//rinkeby multicall 0x0ae6578785868f88478B6bCe8227d6F85703092b
const multicall_address = '0x3eF6A01A0f81D6046290f3e2A8c5b843e738E604';

const poolsData = {
    aave: {
        N_COINS: 3,
        is_aave: true,
        coin_precisions: [1e18, 1e6, 1e6],
        wrapped_precisions: [1e18, 1e6, 1e6],
        use_lending: [false, false, false],
        tethered: [false, false, true],
        is_plain: [false, false, false],
        swap_address: '0x445FE580eF8d70FF569aB36e80c647af338db351',
        token_address: '0xE7a24EF0C5e95Ffb0f6684b813A78F2a3AD7D171',
        gauge_address: '0x19793B454D3AfC7b454F206Ffe95aDE26cA6912c',
        old_gauge: '0xe381C25de995d62b453aF8B931aAc84fcCaa7A62',
        underlying_coins: [
            '0x8f3cf7ad23cd3cadbd9735aff958023239c6a063',
            '0x2791bca1f2de4661ed88a30c99a7a9449aa84174',
            '0xc2132d05d31c914a87c6611c10748aeb04b58e8f',
        ],
        coins: [
            '0x27F8D03b3a2196956ED754baDc28D73be8830A6e',
            '0x1a13F4Ca1d028320A707D99520AbFefca3998b7F',
            '0x60D55F02A771d515e077c9C2403a1ef324885CeC',
        ],
        swap_abi: aaveSwapABI,
        sCurveRewards_abi: paaveRewardsabi,
        sCurveRewards_address: '0xBdFF0C27dd073C119ebcb1299a68A6A92aE607F0',
        reward_token: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
    },
    atricrypto: {
        swap_abi: atriCryptoSwap,
        deposit_abi: atriCryptoZap,
        N_COINS: 5,
        REAL_COINS: 3, //cause this is a fake plain pool
        coin_precisions: [1e18, 1e6, 1e6, 1e8, 1e18],
        wrapped_precisions: [1e18, 1e8, 1e18],
        real_precisions: [1e18, 1e8, 1e18],
        tethered: [false, false, false, false, false],
        use_lending: [false, false, false, false, false],
        is_plain: [true, true, true, true, true],
        swap_address: '0x751B1e21756bDbc307CBcC5085c042a0e9AaEf36',
        token_address: '0x8096ac61db23291252574D49f036f0f9ed8ab390',
        gauge_address: '0xb0a366b987d77b5eD5803cBd95C80bB6DEaB48C0',
        deposit_address: '0x3FCD5De6A9fC8A99995c406c77DDa3eD7E406f81',
        pool_type: 'crypto',
        base_pool: 'aave',
        underlying_coins: [
          '0x8f3cf7ad23cd3cadbd9735aff958023239c6a063', //DAI
          '0x2791bca1f2de4661ed88a30c99a7a9449aa84174', // USDC
          '0xc2132d05d31c914a87c6611c10748aeb04b58e8f', //usdt
          '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6', //WBTC
          '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619', //WETH
        ],
        coins: [
          '0x8f3cf7ad23cd3cadbd9735aff958023239c6a063', //DAI
          '0x2791bca1f2de4661ed88a30c99a7a9449aa84174', // USDC
          '0xc2132d05d31c914a87c6611c10748aeb04b58e8f', //usdt
          '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6', //WBTC
          '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619', //WETH
        ],
    },
    ren: {
        N_COINS: 2,
        is_aave: true,
        coin_precisions: [1e8, 1e8],
        wrapped_precisions: [1e8, 1e8],
        use_lending: [true, false],
        tethered: [false, false],
        is_plain: [false, true],
        swap_address: '0xC2d95EEF97Ec6C17551d45e77B590dc1F9117C67',
        token_address: '0xf8a57c1d3b9629b77b6726a042ca48990A84Fb49',
        gauge_address: '0xffbACcE0CC7C19d46132f1258FC16CF6871D153c',
        old_gauge: '0x93b14f53528a59e655d8ce39bdba443dcddddc4c',
        underlying_coins: [
            '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6',
            '0xDBf31dF14B66535aF65AaC99C32e9eA844e14501',
        ],
        coins: [
          '0x5c2ed810328349100A66B82b78a1791B101C9D61',
          '0xDBf31dF14B66535aF65AaC99C32e9eA844e14501',
        ],
        swap_abi: renSwapABI
    },
};

export {
    infura_url,
    multicall_address,
    poolsData,
};
